// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__4XzOq","square":"Checkbox_square__SxFFn","checked":"Checkbox_checked__XxrrH"};